var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._t("img"),_vm._v(" "),_c('div',{class:{ portrait: _vm.formatPortraitView, 'card-title': true }},[_vm._t("title")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }